import { Stack, useTheme } from '@mui/material';
import {
  IndexContainerStyled,
  LabelContainerStyled,
} from './sector-row.styled';
import { DraggableProvided } from 'react-beautiful-dnd';
import { Bars2Icon } from '@heroicons/react/24/solid';
import { IconSize } from '@constants';

interface SectorRowProps {
  label: string;
  order: number;
  providedDrag: DraggableProvided;
}

const SectorRow = ({ label, order, providedDrag }: SectorRowProps) => {
  const theme = useTheme();
  return (
    <Stack
      alignItems={'center'}
      ref={providedDrag.innerRef}
      {...providedDrag.draggableProps}
      {...providedDrag.dragHandleProps}
      direction="row"
      gap={2}
      mb={1}
    >
      <IndexContainerStyled variant="h4">{order}</IndexContainerStyled>
      <LabelContainerStyled>
        {label}
        <Bars2Icon
          height={IconSize.buttonIcon}
          color={theme.palette.primary.main}
        />
      </LabelContainerStyled>
    </Stack>
  );
};

export default SectorRow;
